import { postTianai } from '../utils/TianaiApiUtil';
import {
  CaptchaChallengeDTO,
  CaptchaCheckParamDTO,
} from '../components/TianaiCaptchaModal/CaptchaType';

const genCaptcha = async (): Promise<CaptchaChallengeDTO | null> => {
  const data = await postTianai<CaptchaChallengeDTO>('/mix/genCaptcha', {});
  if (!data?.id || !data.backgroundImage) {
    return null;
  }
  return data;
};

const checkCaptcha = async (
  param: CaptchaCheckParamDTO,
): Promise<string | null> => {
  const data = await postTianai<{ token?: string }>('/mix/check', param);
  const token = data?.token;
  return token && token.length > 0 ? token : null;
};

export const CaptchaApi = {
  genCaptcha,
  checkCaptcha,
};
